import {useEffect, useState} from "react";
import {commonFilterOptions, outsourceCommonFilterOptions} from "#services/api";
import {$sType} from "@mpc/common/src/utils";
import {useMemoizedFn} from "ahooks";

const filterOptions = function (params: any) {
  const filterOptionsFn = $sType === 'inner' ? commonFilterOptions : outsourceCommonFilterOptions;
  return filterOptionsFn(params)
};


export function useCPMCodeList(props: {
  detailId?: string | number;
  groupType?: string;
}) {
  const { detailId, groupType } = props;
  const [CPMCodeList, setCPMCodeList] = useState([])

  useEffect(() => {
    // 内包不需要获取CPM指标
    if ( $sType === 'inner') return

    if (!detailId || !groupType) return
    if (CPMCodeList?.length) return
    const params = {
      keys: ['content_market_kpi_code'],
      group_type: groupType,
    }
    if (groupType === 'CD_TRUMPET_GROUP') {
      params['trumpet_demand_id'] = detailId
    } else {
      params['demand_id'] = detailId
    }
    // 获取CPM指标列表
    filterOptions?.(params).then((res) => {
      if (res.code === 1) {
        const list = res.data?.[0]?.['options'] || [];
        setCPMCodeList(list)
      }
    })
  }, [detailId, groupType])

  const checkCPM = useMemoizedFn((code: string) => {
    return CPMCodeList?.some((item) => item.value === code)
  })
  return { CPMCodeList,  checkCPM}
}